var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification__popover-footer"},[_c('div',{staticClass:"notification__popover-info_icon"},[_c('font-awesome-icon',{attrs:{"slot":"prefix","icon":['fa', 'info-circle']},slot:"prefix"})],1),_c('div',{staticClass:"info"},[_vm._v(" "+_vm._s(_vm.$t('notifications.footer'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }